import RPMPatientMedications from './patient-medications';
import './style.css';

export default RPMPatientMedications;
